import _ from 'lodash';
import React, { memo } from 'react';
import uniqid from 'uniqid';
import { FileType } from 'util/enums/Enum';
import ValidationControl from '../ValidationControl/ValidationControl';
import Textbox from './Textbox';

interface IProps {
  hideValidationControl?: boolean;
  name: string;
  value: string | number | null;
  dataType?: string;
  onChange?: (event: any) => void;
  onBlur?: (event: any) => void;
  isReadonly: boolean;
  isRequired?: boolean;
  onChangeWithValidation?: (event: any) => void;
  isValid?: boolean;
  validationMessage?: string;
  style?: any;
  precision?: number;
  appendText?: string;
  isDisabled?: boolean;
  fileType?: FileType;
}

export const TextboxControlObject: React.FC<IProps> = (props) => {
  const uid = uniqid();

  return (
    <table>
      <tbody>
        <tr>
          {!props.hideValidationControl ? (
            <td>
              <ValidationControl
                {...props}
                isValid={props.isValid !== undefined ? props.isValid : true}
                message={props.validationMessage ? props.validationMessage : 'An input is required'}
                uid={uid}
              />
            </td>
          ) : (
            ''
          )}
          <td>
            <Textbox {...props} />
          </td>
        </tr>
      </tbody>
    </table>
  );
};

function arePropsEqual(prevProps: IProps, nextProps: IProps) {
  return _.isEqual(_.omit(prevProps, _.functions(prevProps)), _.omit(nextProps, _.functions(nextProps)));
}

export default memo(TextboxControlObject, arePropsEqual);
